export default __webpack_public_path__ + "static/media/sprint_daily.f9a72b3d.png";